import { render, staticRenderFns } from "./VaPopover.demo.vue?vue&type=template&id=28d8e5ed&"
import script from "./VaPopover.demo.vue?vue&type=script&lang=js&"
export * from "./VaPopover.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports